import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/auth/me");
                setUser(data);
            } catch {
                setUser(null);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.requires_2fa) return data;
        if (data.access_token) localStorage.setItem("rd_token", data.access_token);
        setUser(data);
        return data;
    };

    const verify2fa = async (challenge_token, code, trust_device) => {
        const { data } = await api.post("/auth/2fa/verify", { challenge_token, code, trust_device });
        if (data.access_token) localStorage.setItem("rd_token", data.access_token);
        setUser(data);
        return data;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        if (data.access_token) localStorage.setItem("rd_token", data.access_token);
        setUser(data);
        return data;
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch {}
        localStorage.removeItem("rd_token");
        setUser(null);
        // Purge the service worker's caches so a stale /auth/me or dashboard
        // response can never make the next visitor look logged in as the
        // previous user.
        try {
            if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage("PURGE_CACHES");
            }
        } catch {}
    };

    return (
        <AuthCtx.Provider value={{ user, loading, login, verify2fa, register, logout }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
